<template>
    <div class="content_div">
        <el-card>
            <!--商品-->
            <el-form :inline="true" :model="query" class="demo-form-inline" STYLE="margin-bottom: 20px;">
                <el-form-item label="月份">
                    <el-date-picker clearable
                                    v-model="query.month"
                                    type="month"
                                    value-format="yyyy-MM"
                                    placeholder="选择年月">
                    </el-date-picker>
                </el-form-item>
                <!--下单时间，年月日-->
                <el-form-item label="预约时间">
                    <el-date-picker
                        class="input_class"
                        v-model="query.days"
                        type="date"
                        placeholder="请预约时间"
                        value-format="yyyy-MM-dd"
                        clearable>
                    </el-date-picker>
                </el-form-item>
                <!--所属店铺-->
                <el-form-item label="所属店铺">
                    <el-select class="input_class" v-model="query.shopId" placeholder="请选择所属店铺" clearable>
                        <el-option v-for="item in shopList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <!--类型：1员工餐2客户餐-->
                <el-form-item label="订单类型">
                    <el-select class="input_class" v-model="query.type" placeholder="请选择订单类型" clearable>
                        <el-option label="员工餐" value="1"></el-option>
                        <el-option label="客户餐" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <!--订单时段-->
                <el-form-item label="订单时段">
                    <el-select class="input_class" v-model="query.goodsType" placeholder="请选择订单时段" clearable>
                        <el-option label="早餐" value="1"></el-option>
                        <el-option label="午餐" value="2"></el-option>
                        <el-option label="晚餐" value="3"></el-option>
                    </el-select>
                </el-form-item>
                <!--订单状态-->
                <el-form-item label="订单状态">
                    <el-select multiple class="input_class" v-model="query.stateArr" placeholder="请选择订单状态" clearable>
                        <el-option label="已下单" value="1"></el-option>
                        <el-option label="已取消" value="2"></el-option>
                        <el-option label="待评价" value="3"></el-option>
                        <el-option label="已完成" value="4"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="商品名称">
                    <el-input clearable class="input_class" v-model="query.goodsName" auto-complete="off" placeholder="请输入商品名称"></el-input>
                </el-form-item>

                <el-form-item label="员工信息" prop="userId">
                    <template #label>
                  <span style="display:inline-block;">
                      <el-tooltip effect="dark" content="模糊搜索，至多显示10条记录" placement="bottom">
                          <el-icon><QuestionFilled/></el-icon>
                      </el-tooltip>
                      员工姓名/手机号
                    </span>
                    </template>
                    <el-select
                        v-model="query.userId" placeholder="请输入员工姓名/手机号" filterable clearable remote :remote-method="loadUsersList">
                        <el-option v-for="(item, index) in usersList" :key="index"
                                   :label="item.nickname"
                                   :value="item.id"/>
                    </el-select>
                </el-form-item>

                <el-button type="primary" icon="el-icon-search" @click="load">查询</el-button>
                <!--导出-->
                <el-button type="warning" icon="el-icon-download" @click="exportExcel">导出</el-button>
            </el-form>

            <el-table
                :data="list"
                border>
                <el-table-column fixed="left" prop="id" label="编号" width="80"/>
                <el-table-column prop="orderNo" label="订单号" width="160"/>
                <el-table-column prop="shopName" label="所属店铺" width="180"/>
                <el-table-column prop="goodsName" label="商品名称" width="200"/>
                <el-table-column prop="deptName" label="所属部门" width="120"/>
                <el-table-column prop="nickName" label="下单人" width="120"/>
                <el-table-column prop="goodsNum" label="下单数量" width="100"/>
                <el-table-column prop="goodsTotalPrice" label="下单金额" width="100"/>
                <el-table-column prop="days" label="预约时间" width="100"/>
                <el-table-column prop="days" label="代下单" width="100">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.userId===scope.row.createBy">否</el-tag>
                        <el-tag type="danger" v-if="scope.row.userId!==scope.row.createBy">是</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="goodsType" label="订单时段" width="100">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.goodsType===1">早餐</el-tag>
                        <el-tag type="danger" v-if="scope.row.goodsType===2">午餐</el-tag>
                        <el-tag type="success" v-if="scope.row.goodsType===3">晚餐</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="remark" label="订单备注" width="200"></el-table-column>
                <el-table-column prop="type" label="订单类型" width="100">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.type===1">员工餐</el-tag>
                        <el-tag type="success" v-if="scope.row.type===2">客户餐</el-tag>
                    </template>
                </el-table-column>

                <el-table-column prop="state" label="订单状态" width="100">
                    <template slot-scope="scope">
                        <!--                        状态：1已下单；2已取消；3待评价；4已完成-->
                        <el-tag v-if="scope.row.state===1">已下单</el-tag>
                        <el-tag type="info" v-if="scope.row.state===2">已取消</el-tag>
                        <el-tag type="danger" v-if="scope.row.state===3">待评价</el-tag>
                        <el-tag type="success" v-if="scope.row.state===4">已完成</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" label="下单时间" width="160"/>
                <el-table-column prop="completeTime" label="完成时间" width="160"/>
                <el-table-column align="center" label="操作" width="180" v-if="isAdminFlag">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.state!==2 && scope.row.type===2" size="small" type="success"
                                   @click="showVerificationDialog(scope.row)">核销
                        </el-button>
                        <el-button v-if="scope.row.state!==2" size="small" type="danger" @click="btnCancel(scope.row.id)">取消订单</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination style="margin-top:10px;"
                           background
                           layout="total,prev, pager, next"
                           @current-change="currentChange"
                           :total="total">
            </el-pagination>
        </el-card>


        <!-- 核销记录弹窗 -->
        <el-dialog
            :title="`订单核销记录 - ${currentOrder ? currentOrder.orderNo : ''}`"
            :visible.sync="verificationDialogVisible"
            @close="closeVerificationDialog">

            <!-- 核销数量输入 -->
            <div style="margin-bottom: 20px;margin-left: 20px;margin-top:20px;">
                <span style="margin-right: 10px;">核销数量:</span>
                <el-input-number :disabled="currentOrder.state!==1"
                                 v-model="verificationParams.num"
                                 :min="1"
                                 :max="currentOrder ? currentOrder.goodsNum-currentOrder.writeOffCount:0" style="margin-right: 20px;">
                </el-input-number>
                <span style="margin-right: 10px;">核销备注:</span>
                <el-input :disabled="currentOrder.state!==1"
                          v-model="verificationParams.remark"
                          placeholder="请输入核销备注" style="width: 200px; margin-right: 20px;">
                </el-input>
                <el-button :disabled="currentOrder.state!==1" type="primary" @click="handleVerification">核销</el-button>
            </div>

            <!-- 核销记录表格 -->
            <div style="margin:20px;">
                <el-table
                    :data="verificationRecordList"
                    border style="width: 100%">
                    <el-table-column type="index" label="记录ID" width="120"/>
                    <el-table-column prop="nickName" label="操作人" width="120"/>
                    <el-table-column prop="num" label="核销数量" width="100"/>
                    <el-table-column prop="createTime" label="核销时间" width="160"/>
                    <el-table-column prop="remark" label="备注"/>
                </el-table>
            </div>

            <span slot="footer" class="dialog-footer">
        <el-button @click="closeVerificationDialog">关闭</el-button>
    </span>
        </el-dialog>
    </div>
</template>
<script>
import {reqAdminCancelOrder, reqExportOrder, reqListOrder, reqVerifyOrder, reqVerifyOrderRecord} from "@/api/core/Order";
import {reqListShop} from "@/api/core/Shop";
import {reqListAllUsersByPhone} from "../../../api/core/Users";
import user from "@/store/modules/user";

export default {
    name: "ShopOrder",
    async created() {
        let roles = user.state.roles;
        this.isAdminFlag = (roles === 'ROLE_ADMIN')
        await this.loadShop();
        //默认月份为当前月份
        this.query.month = this.getCurrentMonth();
        await this.load();
    },
    data() {
        return {
            query: {
                currentPage: 1,
                pageSize: 10,
                stateArr: ["1","3","4"],
                month:null,
            },
            list: [],
            total: 0,
            shopList: [],
            usersList: [],
            isAdminFlag: false,
            //核销
            verificationDialogVisible: false,
            verificationRecordList: [],
            verificationParams: {
                num: 1,
                remark: "管理员代核销订单",
            },
            currentOrder: {}, // 当前操作的订单
        }
    },
    methods: {
        getCurrentMonth() {
            // 默认月份为当前月份
            const today = new Date();
            // 获取年份和月份并格式化为 "YYYY-MM" 字符串
            const year = today.getFullYear();
            const month = String(today.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需+1，并确保两位数格式
            return `${year}-${month}`;
        },
        async load() {
            this.list = [];
            if (this.query.stateArr) {
                //数组转List
                this.query.stateList = this.query.stateArr.join(",");
            } else {
                this.query.stateList = [];
            }
            let data = await reqListOrder(this.query);
            this.list = data.records;
            this.total = data.total;
        },
        async loadUsersList(phone) {
            this.usersList = [];
            let data = await reqListAllUsersByPhone({phone: phone});
            this.usersList = data;
        },
        async exportExcel() {
            await reqExportOrder(this.query)
                .then(res => {
                    // 创建临时链接并自动下载
                    const blob = new Blob([res], {
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    })
                    const url = window.URL.createObjectURL(blob)
                    const a = document.createElement('a')
                    a.href = url
                    a.download = `订单.xlsx`
                    document.body.appendChild(a)
                    a.click()
                    document.body.removeChild(a)
                    window.URL.revokeObjectURL(url)
                    this.$message.success('导出成功')
                })
                .finally(() => {
                })
        },
        async loadShop() {
            let data = await reqListShop();
            this.shopList = data;
            //this.query.shopId=data[0].id;
        },
        currentChange(num) {
            this.query.currentPage = num;
            this.load();
        },
        async btnCancel(id) {
            this.$confirm('该操作不可逆，确定取消该订单吗？', '提示', {
                confirmButtonText: '确定要取消',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                await reqAdminCancelOrder({id: id});
                this.$message.success("操作成功");
                await this.load();
            }).catch(() => {
            })
        },
        // 显示核销弹窗
        async showVerificationDialog(row) {
            this.currentOrder = row;
            this.verificationParams.id = row.id;
            // 重置数量为1
            this.verificationParams.num = 1;
            this.verificationParams.remark = "管理员代核销订单";
            await this.loadVerificationRecords(row.id);
            this.verificationDialogVisible = true;
        },

        // 加载核销记录
        async loadVerificationRecords(orderId) {
            // 这里需要根据实际后端接口调整
            // 示例：获取该订单的核销记录
            try {
                const data = await reqVerifyOrderRecord({id: orderId});
                this.verificationRecordList = data;
            } catch (error) {
                console.error('加载核销记录失败:', error);
                this.verificationRecordList = [];
            }
        },

        // 执行核销操作
        async handleVerification() {
            if (!this.verificationParams.num || this.verificationParams.num <= 0) {
                this.$message.warning('请输入正确的核销数量');
                return;
            }
            if (this.verificationParams.num > this.currentOrder.num) {
                this.$message.warning('核销数量不能大于订单数量');
                return;
            }
            if (!this.verificationParams.remark) {
                this.$message.warning('请输入核销备注');
                return;
            }
            try {
                await reqVerifyOrder(this.verificationParams);
                this.$message.success('核销成功');
                this.verificationDialogVisible = false;
                await this.load();
            } catch (error) {
                console.error('核销失败:', error);
                this.$message.error('核销失败，请重试');
            }
        },
        // 关闭弹窗
        closeVerificationDialog() {
            this.verificationDialogVisible = false;
            this.verificationRecordList = [];
            this.verificationParams = {};
            this.currentOrder = {};
        }
    }
}
</script>
